import { TraceContextService } from './2v';

export const traceContextService = new TraceContextService();

traceContextService.init();
